module.exports = __webpack_public_path__ + "img/moren-jiabin.be2ad899.jpg";